import React from 'react'
import PropTypes from 'prop-types'
import PreviewCompatibleImage from '../components/PreviewCompatibleImage'

const FeatureGrid = ({ gridItems }) => (
  <div className="feature-grid-wrapper">
    <div className="feature-grid-scroll">
      {gridItems.map((item, index) => (
        <div key={item.text} className="feature-grid-item">
          <div
            className={`feature-card-enhanced animate-fade-in-up`}
            style={{
              animationDelay: `${0.2 + index * 0.1}s`,
              animationFillMode: 'both'
            }}
          >
            <div className="feature-card-accent" />

            <div className="has-text-centered mb-5">
              <div className="feature-image-container">
                <PreviewCompatibleImage
                  imageInfo={item}
                  className="feature-image"
                />
              </div>
            </div>

            <div className="content">
              <p className="feature-text is-size-5-desktop is-size-6-mobile has-text-centered">
                {item.text}
              </p>
            </div>

            <div className="feature-pattern-overlay" />
          </div>
        </div>
      ))}
    </div>
    <div className="feature-scroll-hint">
      <span className="icon">
        <i className="fas fa-chevron-left"></i>
      </span>
      <span>Swipe to explore</span>
      <span className="icon">
        <i className="fas fa-chevron-right"></i>
      </span>
    </div>
  </div>
)

FeatureGrid.propTypes = {
  gridItems: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      text: PropTypes.string,
    })
  ),
}

export default FeatureGrid
